// theme.js
import { createTheme } from '@mui/material/styles';

// MUI theme configuration
export const muiTheme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
    error: {
      main: '#f44336',
    },
    warning: {
      main: '#ff9800',
    },
    info: {
      main: '#2196f3',
    },
    success: {
      main: '#4caf50',
    },
    background: {
      default: '#f5f5f5',
    },
    text: {
      primary: '#000000',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          padding: '24px',
          borderRadius: '8px',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
        },
      },
    },
  },
});

// Ant Design theme configuration
export const antTheme = {
  token: {
    colorPrimary: '#1976d2',
    colorSecondary: '#dc004e',
    colorError: '#f44336',
    colorWarning: '#ff9800',
    colorInfo: '#2196f3',
    colorSuccess: '#4caf50',
    colorBgBase: '#f5f5f5',
    colorTextBase: '#000000',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    borderRadius: 8,
  },
};

export const globalStyles = `
  body {
    background-color: #f0f2f5;
    margin: 0;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  }

  .App-header {
    background-color: #f0f2f5;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: calc(10px + 2vmin);
    color: black;
  }

  .calculator {
    background: white;
    padding: 24px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  .app-container {
    max-width: 60%;
    margin: 0 auto;
    padding: 20px;
  }

  @media screen and (max-width: 768px) {
    .app-container {
      max-width: 100%;
      padding: 0;
    }
  }

  .ant-form-item-label > label {
    white-space: normal;
  }
`;